// SDK情報
export class MPSDKInfo {
    // SDKキー
    public keys = [
        {sdk:'8daa9136445548a0b6ee9143abd2d298', note:'XOOMS Dev'},
        {sdk:'bkyt90fk75x7xe050hp2txkza', note:'exAgent Dev'},
        {sdk:'1tef2rycsgy8yacu6t7n1ky0d', note:'exAgent Production1'},
        {sdk:'2527fp0png0irnqci21uhspud', note:'exAgent Production2'},  //バーチャル植物園
    ]
    
    public versions =[
        '3.6',
        '3.10'
    ]
}